/* eslint-disable @typescript-eslint/no-namespace */
/**
 * Static enums extracted from: @tencent/tpro_rmonitor_metrics_server_get_metrics@4.2.7
 * DO NOT EDIT MANUALLY — run "npm run gen:proto-enums" to regenerate.
 *
 * Zero dependencies — only static enum definitions.
 * Supports nested namespace access: enumTrpc.rmonitor.web_server.IssueType
 */

export namespace enumTrpc {
  export namespace rmonitor {
    export namespace metrics_server {
      export enum TimeType {
        NULL = 0,
        DAY = 1,
        HOUR = 2,
        MINUTE = 3,
        MINUTE5 = 4,
        WEEK = 5,
        MONTH = 6,
        SECOND = 7,
        ACCUMULATED = 8,
      }

      export enum Recency {
        RECENCY_UNSPECIFIED = 0,
        TODAY = 1,
        YESTERDAY = 2,
        LAST_24_HOURS = 3,
        LAST_48_HOURS = 4,
        LAST_7_DAYS = 5,
        LAST_14_DAYS = 6,
        LAST_30_DAYS = 7,
        LAST_60_DAYS = 8,
        LAST_90_DAYS = 9,
      }

      export enum MetricType {
        TYPE_UNSPECIFIED = 0,
        TYPE_DAU = 1,
        TYPE_MEMORY = 2,
        TYPE_FOOM = 3,
        TYPE_LAUNCH = 5,
        TYPE_CRASH = 8,
        TYPE_ANR = 4,
        TYPE_LAG_FPS = 7,
        TYPE_LAG_HANG_RATE = 9,
        TYPE_COMPLIANCE = 10,
        TYPE_FD_LEAK = 15,
        TYPE_BUGLY_DAU = 11,
        TYPE_ERROR = 16,
        TYPE_TRAFFIC_RESOURCE = 18,
        TYPE_FD_LEAK_DAU = 19,
        TYPE_BATTERY_METRIC = 20,
        TYPE_BATTERY_ELEMENTS = 21,
        TYPE_BATTERY_EXCEPTION = 22,
        TYPE_BATTERY_EXCEPTION_DAU = 23,
        TYPE_MEM_DETAIL = 24,
        TYPE_ACTIVITY_LEAK = 25,
        TYPE_HIPPY = 26,
        TYPE_PAGE_LAUNCH = 27,
        TYPE_PAGE_LAUNCH_SPAN = 28,
        TYPE_NETWORK = 29,
        TYPE_LAG_HANG_RATE_NEW = 30,
        TYPE_LAG_RATE = 31,
        TYPE_LAG_DAU = 51,
        TYPE_LAG_RATE_FOR_TIME_COST = 52,
        TYPE_CPU_USAGE_RATE = 32,
        TYPE_CPU_USAGE_RATE_EXCEPTION = 33,
        TYPE_RUM_API = 40,
        TYPE_RUM_LOG = 41,
        TYPE_RUM_PV = 42,
        TYPE_RUM_PERFORMANCE = 43,
        TYPE_RUM_JS = 44,
        TYPE_RUM_EVENT = 45,
        TYPE_RUM_CUSTOM = 46,
        TYPE_RUM_STATIC = 47,
        TYPE_RUM_PERFORMANCE_LAUNCH = 48,
        TYPE_RUM_PERFORMANCE_RUNNING = 49,
        TYPE_RUM_PERFORMANCE_PAGE = 50,
        TYPE_ELECTRON_PV = 53,
        TYPE_ELECTRON_PERFORMANCE = 54,
        TYPE_ELECTRON_JS = 55,
        TYPE_ELECTRON_EVENT = 56,
        TYPE_ELECTRON_CUSTOM = 57,
        TYPE_ELECTRON_STATIC = 58,
        TYPE_ELECTRON_PERFORMANCE_LAUNCH = 59,
        TYPE_ELECTRON_PERFORMANCE_RUNNING = 60,
        TYPE_ELECTRON_PERFORMANCE_PAGE = 61,
        TYPE_ELECTRON_API = 62,
        TYPE_ELECTRON_LOG = 63,
        TYPE_ELECTRON_PERFORMANCE_PAGE_LOAD = 64,
        TYPE_ELECTRON_BROWSER_PERFORMANCE = 65,
        TYPE_ELECTRON_CRASH = 66,
        TYPE_CUSTOM_EVENT = 67,
        TYPE_EXCEPTION_CRASH = 12,
        TYPE_EXCEPTION_ANR = 13,
        TYPE_EXCEPTION_ERROR = 14,
        TYPE_ANDROID_FOOM = 6,
        TYPE_ANDROID_ANR = 17,
        TYPE_APPLICATION_EXIT = 68,
        TYPE_REACT_NATIVE = 69,
        TYPE_ELECTRON_SESSION_DURATION = 70,
        TYPE_AI_MONITOR = 71,
        TYPE_FOOM_VMMAP = 72,
        TYPE_GAME_PERFORMANCE = 73,
        TYPE_HIGH_MEMORY = 74,
        TYPE_DIAGNOSE_AUTO_LOG = 75,
        TYPE_RESOURCE_LEAK = 76,
        TYPE_METRICKIT_FOOM = 77,
        TYPE_ELECTRON_JS_PROMISE_ERROR = 78,
      }

      export enum MetricSubType {
        SUB_TYPE_UNSPECIFIED = 0,
        SUB_TYPE_QIMEI_UV = 1,
        SUB_TYPE_ACCOUNT_UV = 2,
        SUB_TYPE_LAUNCH_TIMES = 3,
        SUB_TYPE_RUNNING_TIME = 4,
        SUB_TYPE_MEMORY_BG_PEAK = 11,
        SUB_TYPE_MEMORY_PG_PEAK = 12,
        SUB_TYPE_MEMORY_VSS = 13,
        SUB_TYPE_MEMORY_PSS = 14,
        SUB_TYPE_MEMORY_JAVA_HEAP = 15,
        SUB_TYPE_MEMORY_REPORT_COUNT = 16,
        SUB_TYPE_LAG_FPS = 47,
        SUB_TYPE_LAG_HANG_RATE = 48,
        SUB_TYPE_LAG_FPS_COUNT = 53,
        SUB_TYPE_LAG_HANG_RATE_COUNT = 54,
        SUB_PRIVACY_COMPLIANCE_API_COUNT = 49,
        SUB_PRIVACY_COMPLIANCE_AVG_API_COUNT = 50,
        SUB_PRIVACY_COMPLIANCE_API_REPORT_COUNT = 51,
        SUB_PRIVACY_COMPLIANCE_QIMEI_UV = 52,
        SUB_PRIVACY_COMPLIANCE_SERIOUS_COUNT = 55,
        SUB_PRIVACY_COMPLIANCE_WARN_COUNT = 56,
        SUB_PRIVACY_COMPLIANCE_HINT_COUNT = 57,
        SUB_TYPE_FD_LEAK_CEIL_QIMEI = 61,
        SUB_TYPE_FD_LEAK_CEIL_ACCOUNT = 62,
        SUB_TYPE_FD_LEAK_CEIL_TIMES = 63,
        SUB_TYPE_FD_LEAK_REPORT_COUNT = 64,
        SUB_TYPE_FD_LEAK_ACCOUNTID_COUNT = 109,
        SUB_TYPE_FD_LEAK_QIMEI_COUNT = 110,
        SUB_TYPE_FD_LEAK_P50 = 111,
        SUB_TYPE_COUNT = 71,
        SUB_TYPE_USER_UV = 72,
        SUB_TYPE_DEVICE_UV = 73,
        SUB_TYPE_DAU_COUNT = 74,
        SUB_TYPE_DAU_USER_UV = 75,
        SUB_TYPE_DAU_DEVICE_UV = 76,
        SUB_TYPE_AVG_DEVICE_RATIO = 77,
        SUB_TYPE_USER_RATIO = 78,
        SUB_TYPE_DEVICE_RATIO = 79,
        SUB_TYPE_LAUNCH_COUNT = 80,
        SUB_TYPE_COUNT_RATIO = 81,
        SUB_TYPE_UNIT_TIME = 82,
        SUB_TYPE_COUNT_INCLUDE_WARM_RATIO = 83,
        SUB_TYPE_LAUNCH_COUNT_INCLUDE_WARM = 84,
        SUB_TYPE_DAU_SESSION_UV = 85,
        SUB_TYPE_SESSION_UV = 86,
        SUB_TYPE_SINGLE_PROCESS = 91,
        SUB_TYPE_TEN_MINUTES = 92,
        SUB_TYPE_CUSTOM = 93,
        SUB_TYPE_TRAFFIC_EXCEPTION = 94,
        SUB_TYPE_FOREGROUND_CURRENT = 95,
        SUB_TYPE_BATTERY_TEMPERATURE = 96,
        SUB_TYPE_SCENE = 97,
        SUB_TYPE_CPU_RATE = 98,
        SUB_TYPE_PROCESS_CPU_TIME = 99,
        SUB_TYPE_LOCATION_FREQUENCY = 100,
        SUB_TYPE_LOCATION_DURATION = 101,
        SUB_TYPE_WAKE_LOCK_FREQUENCY = 102,
        SUB_TYPE_WAKE_LOCK_DURATION = 103,
        SUB_TYPE_ALARM_FREQUENCY = 104,
        SUB_TYPE_ALARM_WAKE_UP_FREQUENCY = 105,
        SUB_TYPE_PROCESS_ALIVE_DURATION = 106,
        SUB_TYPE_FOREGROUND_DURATION = 107,
        SUB_TYPE_BACKGROUND_DURATION = 108,
        SUB_TYPE_PAGE_LAUNCH_PAGE_RENDER_TIME = 113,
        SUB_TYPE_PAGE_LAUNCH_PAGE_LOADE_TIME = 114,
        SUB_TYPE_PAGE_LAUNCH_INSTANT_LOADE_RATE = 115,
        SUB_TYPE_PAGE_LAUNCH_SLOW_LOADE_RATE = 116,
        SUB_TYPE_PAGE_LAUNCH_BOUNCE_RATE = 117,
        SUB_TYPE_PAGE_LAUNCH_SPAN_COST_TIME = 118,
        SUB_TYPE_RUM_PERFORMANCE_APP_LAUNCH = 200,
        SUB_TYPE_RUM_PERFORMANCE_TOTAL_RENDER = 201,
        SUB_TYPE_RUM_PERFORMANCE_LOAD_PACKAGE = 202,
        SUB_TYPE_RUM_PERFORMANCE_SCRIPT_EVALUATE = 203,
        SUB_TYPE_RUM_PERFORMANCE_FIRST_PAINT = 204,
        SUB_TYPE_RUM_PERFORMANCE_FCP = 205,
        SUB_TYPE_RUM_PERFORMANCE_LCP = 206,
        SUB_TYPE_RUM_PERFORMANCE_PAGE_ROUTE = 207,
        SUB_TYPE_RUM_PERFORMANCE_FIRST_SCREEN = 208,
        SUB_TYPE_ELECTRON_PERFORMANCE_APP_LAUNCH = 209,
        SUB_TYPE_ELECTRON_PERFORMANCE_TOTAL_RENDER = 210,
        SUB_TYPE_ELECTRON_PERFORMANCE_LOAD_PACKAGE = 211,
        SUB_TYPE_ELECTRON_PERFORMANCE_SCRIPT_EVALUATE = 212,
        SUB_TYPE_ELECTRON_PERFORMANCE_FIRST_PAINT = 213,
        SUB_TYPE_ELECTRON_PERFORMANCE_FCP = 214,
        SUB_TYPE_ELECTRON_PERFORMANCE_LCP = 215,
        SUB_TYPE_ELECTRON_PERFORMANCE_PAGE_ROUTE = 216,
        SUB_TYPE_ELECTRON_PERFORMANCE_FIRST_SCREEN = 217,
        SUB_TYPE_ELECTRON_PERFORMANCE_DOM_PARSE = 218,
        SUB_TYPE_ELECTRON_PERFORMANCE_CLS = 219,
        SUB_TYPE_ELECTRON_PERFORMANCE_INP = 220,
        SUB_TYPE_ELECTRON_PERFORMANCE_DNS = 221,
        SUB_TYPE_ELECTRON_PERFORMANCE_SSL = 222,
        SUB_TYPE_ELECTRON_PERFORMANCE_TTFB = 223,
        SUB_TYPE_ELECTRON_PERFORMANCE_CONTENT_DOWNLOAD = 224,
        SUB_TYPE_ELECTRON_PERFORMANCE_RESOURCE_DOWNLOAD = 225,
        SUB_TYPE_ELECTRON_PERFORMANCE_TCP = 226,
        SUB_TYPE_ELECTRON_SYS_USED_MEMORY = 227,
        SUB_TYPE_ELECTRON_SYS_USED_MEMORY_RATE = 228,
        SUB_TYPE_ELECTRON_SYS_USED_CPU_RATE = 229,
        SUB_TYPE_ELECTRON_PROCESS_USED_MEMORY = 230,
        SUB_TYPE_ELECTRON_PROCESS_USED_MEMORY_RATE = 231,
        SUB_TYPE_ELECTRON_PROCESS_USED_CPU_RATE = 232,
        SUB_TYPE_ELECTRON_SESSION_COUNT = 233,
        SUB_TYPE_ELECTRON_ACTIVE_USER_COUNT = 234,
        SUB_TYPE_ELECTRON_CRASH_COUNT = 235,
        SUB_TYPE_ELECTRON_CRASH_USER_COUNT = 236,
        SUB_TYPE_ELECTRON_CRASH_DEVICE_COUNT = 237,
        SUB_TYPE_ELECTRON_SESSION_CRASH_RATE = 238,
        SUB_TYPE_ELECTRON_USER_CRASH_RATE = 239,
        SUB_TYPE_ELECTRON_DEVICE_CRASH_RATE = 240,
        SUB_TYPE_PROCESS_LAUNCH_QIMEI_COUNT = 300,
        SUB_TYPE_LAUNCH_QIMEI_COUNT = 301,
        SUB_TYPE_LAG_RATE_TIME_COST_LEVEL1 = 400,
        SUB_TYPE_LAG_RATE_TIME_COST_LEVEL2 = 401,
        SUB_TYPE_LAG_RATE_TIME_COST_LEVEL3 = 402,
        SUB_TYPE_LAG_COUNT_TIME_COST_LEVEL1 = 403,
        SUB_TYPE_LAG_COUNT_TIME_COST_LEVEL2 = 404,
        SUB_TYPE_LAG_COUNT_TIME_COST_LEVEL3 = 405,
        SUB_TYPE_LAG_TIME_COST_P50 = 406,
        SUB_TYPE_LAG_TIME_COST_P90 = 407,
        SUB_TYPE_LAG_TIME_COST_P95 = 408,
        SUB_TYPE_LAG_TIME_COST_P99 = 409,
        SUB_TYPE_FOOM_QIMEI = 21,
        SUB_TYPE_FOOM_ACCOUNT = 22,
        SUB_TYPE_FOOM_TIMES = 23,
        SUB_TYPE_FOOM_UNIT_TIME = 24,
        SUB_TYPE_FOOM_REPORT_COUNT = 25,
        SUB_TYPE_ANR_QIMEI = 31,
        SUB_TYPE_ANR_ACCOUNT = 32,
        SUB_TYPE_ANR_TIMES = 33,
        SUB_TYPE_ANR_UNIT_TIME = 34,
        SUB_TYPE_ANR_REPORT_COUNT = 35,
        SUB_TYPE_EXCEPTION_AFFECT_COUNT = 41,
        SUB_TYPE_EXCEPTION_AFFECT_USER_COUNT = 42,
        SUB_TYPE_EXCEPTION_AFFECT_DEVICE_COUNT = 43,
        SUB_TYPE_EXCEPTION_ACCESS_COUNT = 44,
        SUB_TYPE_EXCEPTION_ACCESS_USER_COUNT = 45,
        SUB_TYPE_EXCEPTION_ACCESS_DEVICE_COUNT = 46,
        SUB_TYPE_AI_MONITOR_TOKEN_RATE = 350,
        SUB_TYPE_AI_MONITOR_FIRST_PACKAGE_COST = 351,
        SUB_TYPE_AI_MONITOR_ERR_RATE = 352,
        SUB_TYPE_AI_MONITOR_FREEZE_RATE = 353,
        SUB_TYPE_AI_MONITOR_FLUENCY = 354,
        SUB_TYPE_GAME_PERFORMANCE_FPS_AVG = 360,
        SUB_TYPE_GAME_PERFORMANCE_FPS_STUTTER = 361,
        SUB_TYPE_GAME_PERFORMANCE_ONE_PERCENT_LOW = 362,
        SUB_TYPE_GAME_PERFORMANCE_JANK_COUNT_PER_TABLE = 364,
        SUB_TYPE_GAME_PERFORMANCE_STUTTER_PER_TEN_MINUTES = 365,
        SUB_TYPE_GAME_PERFORMANCE_JANK_PER_TEN_MINUTES = 366,
        SUB_TYPE_GAME_PERFORMANCE_BIG_JANK_PER_TEN_MINUTES = 367,
        SUB_TYPE_GAME_PERFORMANCE_BIG_JANK_PER_TABLE = 369,
        SUB_TYPE_GAME_PERFORMANCE_ONE_PERCENT_LOW_FPS_FB = 370,
        SUB_TYPE_GAME_PERFORMANCE_ONE_PERCENT_LOW_FPS_TB = 371,
        SUB_TYPE_GAME_PERFORMANCE_FPS_VARIANCE = 372,
        SUB_TYPE_GAME_PERFORMANCE_ONE_PERCENT_LOW_FPS_SEGMENT_FB = 373,
        SUB_TYPE_GAME_PERFORMANCE_ONE_PERCENT_LOW_FPS_SEGMENT_TB = 374,
        SUB_TYPE_GAME_PERFORMANCE_FPS_SEGMENT = 375,
        SUB_TYPE_GAME_PERFORMANCE_WINDOWS_WORKING_SET = 380,
        SUB_TYPE_GAME_PERFORMANCE_WINDOWS_PRIVATE_BYTES = 381,
        SUB_TYPE_GAME_PERFORMANCE_WINDOWS_GPU_MEM_PROCESS_USAGE = 382,
        SUB_TYPE_GAME_PERFORMANCE_WINDOWS_CPU_APP_USAGE = 383,
        SUB_TYPE_GAME_PERFORMANCE_WINDOWS_GPU_USAGE = 384,
        SUB_TYPE_GAME_PERFORMANCE_WINDOWS_GPU_TEMPERATURE = 385,
        SUB_TYPE_GAME_PERFORMANCE_WINDOWS_IO_READ_COUNT = 386,
        SUB_TYPE_GAME_PERFORMANCE_WINDOWS_IO_READ_BYTES = 387,
        SUB_TYPE_GAME_PERFORMANCE_WINDOWS_IO_WRITE_COUNT = 388,
        SUB_TYPE_GAME_PERFORMANCE_WINDOWS_IO_WRITE_BYTES = 389,
        SUB_TYPE_GAME_PERFORMANCE_SCENE_LOAD_DURATION = 390,
        SUB_TYPE_GAME_PERFORMANCE_SCENE_WHOLE_DURATION = 391,
        SUB_TYPE_GAME_PERFORMANCE_NET_LATENCY = 392,
        SUB_TYPE_GAME_PERFORMANCE_COUNT = 393,
        SUB_TYPE_GAME_PERFORMANCE_FOOTPRINT_MAX = 394,
        SUB_TYPE_GAME_PERFORMANCE_RESIDENT_AVG = 395,
        SUB_TYPE_GAME_PERFORMANCE_MEM_PROCESS_AVAILABLE_AVG = 396,
        SUB_TYPE_GAME_PERFORMANCE_MEM_AVAILABLE_AVG = 397,
        SUB_TYPE_GAME_PERFORMANCE_CPU_USAGE_AVG = 398,
        SUB_TYPE_GAME_PERFORMANCE_CPU_TEMPERATURE_LEVEL_AVG = 399,
        SUB_TYPE_GAME_PERFORMANCE_ELECTRIC_CURRENT_AVG = 500,
        SUB_TYPE_GAME_PERFORMANCE_ELECTRIC_POWER_AVG = 501,
        SUB_TYPE_GAME_PERFORMANCE_BATTERY_TEMPERATURE_AVG = 502,
        SUB_TYPE_GAME_PERFORMANCE_ELECTRIC_POWER = 503,
        SUB_TYPE_GAME_PERFORMANCE_PSS = 504,
        SUB_TYPE_NETWORK_TOTAL_COST = 505,
        SUB_TYPE_NETWORK_DNS_COST = 506,
        SUB_TYPE_NETWORK_TCP_COST = 507,
        SUB_TYPE_NETWORK_SSL_COST = 508,
        SUB_TYPE_NETWORK_REQUEST_COST = 509,
        SUB_TYPE_NETWORK_WAIT_COST = 510,
        SUB_TYPE_NETWORK_RESPONSE_COST = 511,
        SUB_TYPE_NETWORK_FIRST_BYTE_COST = 512,
        SUB_TYPE_NETWORK_REQUEST_BYTES = 513,
        SUB_TYPE_NETWORK_RESPONSE_BYTES = 514,
        SUB_TYPE_NETWORK_REPORT_COUNT = 515,
        SUB_TYPE_NETWORK_USER_COUNT = 516,
        SUB_TYPE_NETWORK_SUCCESS_RATE = 517,
        SUB_TYPE_NETWORK_CONNECTION_REUSE_RATE = 518,
        SUB_TYPE_NETWORK_ERROR_COUNT = 519,
        SUB_TYPE_ELECTRON_RENDERER_USED_MEMORY = 1001,
        SUB_TYPE_ELECTRON_RENDERER_USED_MEMORY_RATE = 1002,
        SUB_TYPE_ELECTRON_RENDERER_USED_CPU_RATE = 1003,
        SUB_TYPE_ELECTRON_SUBPROCESS_USED_MEMORY = 1004,
        SUB_TYPE_ELECTRON_SUBPROCESS_USED_MEMORY_RATE = 1005,
        SUB_TYPE_ELECTRON_SUBPROCESS_USED_CPU_RATE = 1006,
      }

      export enum MetricName {
        METRIC_NAME_UNKNOWN = 0,
        METRIC_NAME_AVG = 1,
        METRIC_NAME_P50 = 2,
        METRIC_NAME_P75 = 23,
        METRIC_NAME_P90 = 3,
        METRIC_NAME_P99 = 4,
        METRIC_NAME_P95 = 5,
        METRIC_NAME_COUNT = 11,
        METRIC_NAME_USER_UV = 12,
        METRIC_NAME_DEVICE_UV = 13,
        METRIC_NAME_LAUNCH_COUNT = 14,
        METRIC_NAME_USER_RATIO = 15,
        METRIC_NAME_DEVICE_RATIO = 16,
        METRIC_NAME_COUNT_RATIO = 17,
        METRIC_NAME_UNIT_TIME = 18,
        METRIC_NAME_DAU_DEVICE_UV = 19,
        METRIC_NAME_USER_PROPORTION = 20,
        METRIC_NAME_ERR_COUNT = 21,
        METRIC_NAME_FPS_AVG = 24,
        METRIC_NAME_FPS_STUTTER = 25,
        METRIC_NAME_ONE_PERCENT_LOW_FPS_FB = 26,
        METRIC_NAME_JANK_COUNT = 27,
        METRIC_NAME_BIG_JANK_COUNT = 28,
        METRIC_NAME_WINDOWS_WORKING_SET = 29,
        METRIC_NAME_WINDOWS_PRIVATE_BYTES = 30,
      }

      export enum TopSortMode {
        MODE_UNSPECIFIED = 0,
        MODE_ACCESS_COUNT_DESC = 1,
        MODE_ACCESS_USER_COUNT_DESC = 2,
        MODE_ACCESS_DEVICE_COUNT_DESC = 3,
        MODE_AFFECTED_COUNT_DESC = 4,
        MODE_AFFECTED_USER_COUNT_DESC = 5,
        MODE_AFFECTED_DEVICE_COUNT_DESC = 6,
      }

      export enum KeyType {
        NORAML = 0,
      }

    }

    export namespace web_server {
      export enum StackInfoType {
        STACK_INFO_ALL = 0,
        STACK_INFO_WITH_STACK = 1,
        STACK_INFO_WITHOUT_STACK = 2,
      }

      export enum AnalyzedType {
        ANALYZED_TYPE_UNSPECIFIED = 0,
        ANALYZED_TYPE_SERVER = 1,
        ANALYZED_TYPE_CLIENT = 2,
      }

      export enum TicketStatus {
        TICKET_STATUS_UNSPECIFIED = 0,
        TICKET_STATUS_UNCOMMITED = 1,
        TICKET_STATUS_COMMITED = 2,
      }

      export enum IssueStatus {
        ISSUE_STATUS_UNSPECIFIED = 0,
        ISSUE_STATUS_UNSOLVED = 1,
        ISSUE_STATUS_SOLVING = 2,
        ISSUE_STATUS_SOLVED = 3,
        ISSUE_STATUS_HANGUP = 4,
      }

      export enum IssueType {
        ISSUE_TYPE_UNKNOWN = 0,
        ISSUE_TYPE_DAU = 55,
        ISSUE_TYPE_CRASH = 1,
        ISSUE_TYPE_ERROR = 2,
        ISSUE_TYPE_ANR_BUGLY = 3,
        ISSUE_TYPE_ANR = 4,
        ISSUE_TYPE_LAG = 5,
        ISSUE_TYPE_FOOM = 6,
        ISSUE_TYPE_MEM_LEAK = 7,
        ISSUE_TYPE_BITMAP = 8,
        ISSUE_TYPE_BADMALLOC = 9,
        ISSUE_TYPE_NATIVE_MEM = 10,
        ISSUE_TYPE_FD_LEAK = 11,
        ISSUE_TYPE_METRICKIT = 12,
        ISSUE_TYPE_MEM_GRAPH = 13,
        ISSUE_TYPE_LAUNCH = 14,
        ISSUE_TYPE_FOOM_BUGLY = 15,
        ISSUE_TYPE_FOOM_MALLOC = 16,
        ISSUE_TYPE_APP_EXIST = 21,
        ISSUE_TYPE_TRAFFIC = 23,
        ISSUE_TYPE_TRAFFIC_EXCEPTION = 56,
        ISSUE_TYPE_BATTERY_PROBLEM = 26,
        ISSUE_TYPE_BATTERY_ELEMENT = 28,
        ISSUE_TYPE_BATTERY_METRIC = 29,
        ISSUE_TYPE_CRASH_FOR_SUB_ISSUE = 27,
        ISSUE_TYPE_ANR_FOR_SUB_ISSUE = 30,
        ISSUE_TYPE_ERROR_FOR_SUB_ISSUE = 31,
        ISSUE_TYPE_NETWORK_HTTP = 32,
        ISSUE_TYPE_NETWORK_ERROR = 33,
        ISSUE_TYPE_LAG_ANR_TRACE = 34,
        ISSUE_TYPE_MEMORY_DETAIL = 35,
        ISSUE_TYPE_PAGE_LAUNCH_COST = 44,
        ISSUE_TYPE_PAGE_LAUNCH_SPAN = 45,
        ISSUE_TYPE_RESOURCE_LEAK = 92,
        ISSUE_TYPE_RUM_API = 36,
        ISSUE_TYPE_RUM_LOG = 37,
        ISSUE_TYPE_RUM_PV = 38,
        ISSUE_TYPE_RUM_HIPPY_PERFORAMANCE = 39,
        ISSUE_TYPE_RUM_JS = 40,
        ISSUE_TYPE_RUM_EVENT = 41,
        ISSUE_TYPE_RUM_CUSTOM = 42,
        ISSUE_TYPE_RUM_STATIC = 43,
        ISSUE_TYPE_RUM_PAGE_LOAD = 46,
        ISSUE_TYPE_RUM_PERFORAMANCE_LAUNCH = 49,
        ISSUE_TYPE_RUM_PERFORAMANCE_RUNNING = 50,
        ISSUE_TYPE_RUM_PERFORAMANCE_PAGE = 51,
        ISSUE_TYPE_RUM_KOTLIN_EXCEPTION = 59,
        ISSUE_TYPE_AUTO_LOG = 1006,
        ISSUE_TYPE_MANUAL_LOG = 1007,
        ISSUE_TYPE_COMPLIANC_API = 17,
        ISSUE_TYPE_COMPLIANC_FUNC_INVOKE = 18,
        ISSUE_TYPE_COMPLIANC_DOWNLOAD_MONITOR = 19,
        ISSUE_TYPE_COMPLIANCE_SELF_LAUNCH = 20,
        ISSUE_TYPE_COMPLIANCE_NETWORK_CAPTURE = 22,
        ISSUE_TYPE_COMPLIANC_PERMISSION = 24,
        ISSUE_TYPE_COMPLIANCE_FILE_ACCESS = 48,
        ISSUE_TYPE_COMPLIANCE_CROSS_BORDER = 214,
        ISSUE_TYPE_COMPLIANCE_FLARE = 215,
        ISSUE_TYPE_TRAFFIC_INNER = 25,
        ISSUE_TYPE_TRAFFIC_APART_INNER = 47,
        ISSUE_TYPE_HIPPY = 52,
        ISSUE_TYPE_KUIKLY = 53,
        ISSUE_TYPE_MINIPROGRAM = 54,
        ISSUE_TYPE_TRAFFIC_METRIC_INNER = 60,
        ISSUE_TYPE_LAG_DAU = 61,
        ISSUE_TYPE_HIGH_CPU_STACK = 62,
        ISSUE_TYPE_ELECTRON_CRASH = 63,
        ISSUE_TYPE_ELECTRON_JS = 64,
        ISSUE_TYPE_ELECTRON_PERFORAMANCE_PAGE = 65,
        ISSUE_TYPE_ELECTRON_PERFORAMANCE_PROCESS = 66,
        ISSUE_TYPE_ELECTRON_VISIT = 67,
        ISSUE_TYPE_ELECTRON_WHITE_SCREEN = 68,
        ISSUE_TYPE_ELECTRON_API = 69,
        ISSUE_TYPE_ELECTRON_STATIC = 70,
        ISSUE_TYPE_ELECTRON_EVENT = 71,
        ISSUE_TYPE_ELECTRON_CUSTOM = 72,
        ISSUE_TYPE_ELECTRON_SESSION = 73,
        ISSUE_TYPE_ELECTRON_LOG = 74,
        ISSUE_TYPE_ELECTRON_PV = 75,
        ISSUE_TYPE_ELECTRON_LOG_DETAIL = 76,
        ISSUE_TYPE_ELECTRON_PERFORAMANCE_PAGE_LOAD = 77,
        ISSUE_TYPE_RN_JS = 80,
        ISSUE_TYPE_RN_EVENT = 81,
        ISSUE_TYPE_RN_CUSTOM = 82,
        ISSUE_TYPE_RN_LOG = 83,
        ISSUE_TYPE_RN_PV = 84,
        ISSUE_TYPE_AI_MONITOR = 85,
        ISSUE_TYPE_CRASH_JOIN_AI_MONITOR = 86,
        ISSUE_TYPE_GAME_PERFORMANCE = 87,
        ISSUE_TYPE_TRACE_EVENT = 88,
        ISSUE_TYPE_HIGH_MEMORY = 89,
        ISSUE_TYPE_DIAGNOSE_AUTO_LOG = 90,
        ISSUE_TYPE_SEGMENT_LAG = 91,
        ISSUE_TYPE_METRICKIT_FOOM = 93,
        ISSUE_TYPE_ELECTRON_JS_PROMISE_ERROR = 94,
        ISSUE_TYPE_EXCEPTION = 1001,
        ISSUE_TYPE_LAG_Metric = 1002,
        ISSUE_TYPE_MEM_Metric = 1003,
        ISSUE_TYPE_MAU_Metric = 1004,
        ISSUE_TYPE_OLD_OPENAPI_REQUEST = 1005,
        ISSUE_TYPE_NETWORK_DIAGNOSE = 95,
      }

      export enum IssueMetricType {
        ISSUE_METRIC_UNKNOWN = 0,
        ISSUE_METRIC_REPORT_COUNT = 1,
        ISSUE_METRIC_USER_COUNT = 2,
        ISSUE_METRIC_DEVICE_COUNT = 3,
        ISSUE_METRIC_P90_MALLOC_SIZE = 4,
        ISSUE_METRIC_P50_MALLOC_SIZE = 5,
        ISSUE_METRIC_AVG_MALLOC_SIZE = 6,
        ISSUE_METRIC_EXCEPTION_COUNT = 7,
        ISSUE_METRIC_NORMAL_COUNT = 8,
        ISSUE_METRIC_EXIT_RATE = 9,
        ISSUE_METRIC_AVG_TRAFFIC = 10,
        ISSUE_METRIC_P25_TRAFFIC = 11,
        ISSUE_METRIC_P50_TRAFFIC = 12,
        ISSUE_METRIC_P75_TRAFFIC = 13,
        ISSUE_METRIC_P50_LAUNCH_COST = 14,
        ISSUE_METRIC_P50_LAG_COST = 15,
        ISSUE_METRIC_P50_MEM_LEAK_SIZE = 16,
        ISSUE_METRIC_P50_BITMAP_SIZE = 17,
        ISSUE_METRIC_P50_FD_LEAK_COUNT = 18,
        ISSUE_METRIC_P50_MEM_GRAPH_SIZE = 19,
        ISSUE_METRIC_HTTP_SUCC_RATE = 20,
        ISSUE_METRIC_HTTP_CONNECTION_RATE = 21,
        ISSUE_METRIC_HTTP_ERR_COUNT = 22,
        ISSUE_METRIC_AVG_HTTP_TOTAL_COST = 23,
        ISSUE_METRIC_P50_HTTP_TOTAL_COST = 24,
        ISSUE_METRIC_AVG_HTTP_DNS_COST = 25,
        ISSUE_METRIC_P50_HTTP_DNS_COST = 26,
        ISSUE_METRIC_AVG_HTTP_TCP_COST = 27,
        ISSUE_METRIC_P50_HTTP_TCP_COST = 28,
        ISSUE_METRIC_AVG_HTTP_SSL_COST = 29,
        ISSUE_METRIC_P50_HTTP_SSL_COST = 30,
        ISSUE_METRIC_AVG_HTTP_REQ_COST = 31,
        ISSUE_METRIC_P50_HTTP_REQ_COST = 32,
        ISSUE_METRIC_AVG_HTTP_WAIT_COST = 33,
        ISSUE_METRIC_P50_HTTP_WAIT_COST = 34,
        ISSUE_METRIC_AVG_HTTP_RES_COST = 35,
        ISSUE_METRIC_P50_HTTP_RES_COST = 36,
        ISSUE_METRIC_AVG_HTTP_FIRST_PACKAGE_COST = 37,
        ISSUE_METRIC_P50_HTTP_FIRST_PACKAGE_COST = 38,
        ISSUE_METRIC_AVG_HTTP_REQ_SIZE = 39,
        ISSUE_METRIC_P50_HTTP_REQ_SIZE = 40,
        ISSUE_METRIC_AVG_HTTP_RES_SIZE = 41,
        ISSUE_METRIC_P50_HTTP_RES_SIZE = 42,
        ISSUE_METRIC_HTTP_ERR_RATE = 43,
        ISSUE_METRIC_HTTP_USER_RATE = 44,
        ISSUE_METRIC_HTTP_ERR_USER_COUNT = 45,
        ISSUE_METRIC_RUM_API_COUNT = 46,
        ISSUE_METRIC_RUM_API_DURATION_AVG = 47,
        ISSUE_METRIC_RUM_API_DURATION_QUANTILE = 48,
        ISSUE_METRIC_RUM_API_ERR_COUNT = 52,
        ISSUE_METRIC_RUM_API_ERR_RATE = 53,
        ISSUE_METRIC_RUM_API_STATUS_ERR_COUNT = 54,
        ISSUE_METRIC_RUM_API_RET_ERR_COUNT = 55,
        ISSUE_METRIC_DAU_LAUNCH_TIMES = 56,
        ISSUE_METRIC_DAU_DEVICE_UV = 57,
        ISSUE_METRIC_RUM_API_BRIDGE_DURATION_AVG = 58,
        ISSUE_METRIC_RUM_API_BRIDGE_DURATION_QUANTILE = 59,
        ISSUE_METRIC_RUM_API_NET_DURATION_AVG = 62,
        ISSUE_METRIC_RUM_API_NET_DURATION_QUANTILE = 63,
        ISSUE_METRIC_RUM_JS_OTHER_ERROR = 66,
        ISSUE_METRIC_RUM_JS_PROMISE_ERROR = 67,
        ISSUE_METRIC_RUM_JS_AJAX_ERROR = 68,
        ISSUE_METRIC_RUM_JS_LOAD_ERROR = 69,
        ISSUE_METRIC_RUM_JS_PICTURE_LOAD_ERROR = 70,
        ISSUE_METRIC_RUM_JS_CSS_LOAD_ERROR = 71,
        ISSUE_METRIC_RUM_JS_NATIVE_ERROR = 72,
        ISSUE_METRIC_RUM_JS_HIPPY_ERROR = 73,
        ISSUE_METRIC_RUM_JS_ERROR_COUNT = 74,
        ISSUE_METRIC_RUM_PERFORMANCE_COUNT = 75,
        ISSUE_METRIC_AVG_RUM_PERFORMANCE_NATIVE = 76,
        ISSUE_METRIC_AVG_RUM_PERFORMANCE_JS = 77,
        ISSUE_METRIC_AVG_RUM_PERFORMANCE_RUN = 78,
        ISSUE_METRIC_AVG_RUM_PERFORMANCE_DOM = 79,
        ISSUE_METRIC_AVG_RUM_PERFORMANCE_FIRST_FRAME = 80,
        ISSUE_METRIC_AVG_RUM_PERFORMANCE_FP = 81,
        ISSUE_METRIC_AVG_RUM_PERFORMANCE_FCP = 82,
        ISSUE_METRIC_AVG_RUM_PERFORMANCE_CUSTOM_DURATION = 83,
        ISSUE_METRIC_SEO_RUM_PERFORMANCE_FP = 84,
        ISSUE_METRIC_SEO_RUM_PERFORMANCE_FCP = 85,
        ISSUE_METRIC_SEO_RUM_PERFORMANCE_CUSTOM_DURATION = 86,
        ISSUE_METRIC_QUANTILE_RUM_PERFORMANCE_NATIVE = 87,
        ISSUE_METRIC_QUANTILE_RUM_PERFORMANCE_JS = 88,
        ISSUE_METRIC_QUANTILE_RUM_PERFORMANCE_RUN = 89,
        ISSUE_METRIC_QUANTILE_RUM_PERFORMANCE_DOM = 90,
        ISSUE_METRIC_QUANTILE_RUM_PERFORMANCE_FIRST_FRAME = 91,
        ISSUE_METRIC_QUANTILE_RUM_PERFORMANCE_FP = 92,
        ISSUE_METRIC_QUANTILE_RUM_PERFORMANCE_FCP = 93,
        ISSUE_METRIC_QUANTILE_RUM_PERFORMANCE_CUSTOM_DURATION = 94,
        ISSUE_METRIC_RUM_PV_COUNT = 95,
        ISSUE_METRIC_RUM_PV_UV_COUNT = 96,
        ISSUE_METRIC_RUM_STATIC_SUCCESS_RATE = 97,
        ISSUE_METRIC_RUM_STATIC_RET_FAIL_COUNT = 98,
        ISSUE_METRIC_RUM_STATIC_STATUS_FAIL_COUNT = 99,
        ISSUE_METRIC_RUM_STATIC_COUNT = 100,
        ISSUE_METRIC_RUM_STATIC_DURATION_AVG = 101,
        ISSUE_METRIC_RUM_STATIC_DURATION_QUANTILE = 102,
        ISSUE_METRIC_RUM_STATIC_TRANSFER_SIZE_AVG = 103,
        ISSUE_METRIC_RUM_STATIC_TRANSFER_SIZE_QUANTILE = 104,
        ISSUE_METRIC_RUM_STATIC_DOMAIN_LOOK_UP_AVG = 105,
        ISSUE_METRIC_RUM_STATIC_DOMAIN_LOOK_UP_QUANTILE = 106,
        ISSUE_METRIC_RUM_STATIC_CONNECT_TIME_AVG = 107,
        ISSUE_METRIC_RUM_STATIC_CONNECT_TIME_QUANTILE = 108,
        ISSUE_METRIC_RUM_CUSTOM_COUNT = 109,
        ISSUE_METRIC_RUM_CUSTOM_DURATION_AVG = 110,
        ISSUE_METRIC_RUM_CUSTOM_DURATION_QUANTILE = 111,
        ISSUE_METRIC_RUM_EVENT_PV_COUNT = 112,
        ISSUE_METRIC_RUM_EVENT_UV_COUNT = 113,
        ISSUE_METRIC_RUM_JS_ERROR_RATE = 114,
        ISSUE_METRIC_RUM_ERROR_NATIVE_ERROR = 115,
        ISSUE_METRIC_RUM_ERROR_CROSS_ERROR = 116,
        ISSUE_METRIC_RUM_NATIVE_CROSS_ERROR = 117,
        ISSUE_METRIC_AVG_RUM_PERFORMANCE_FETCH_CONTEXT = 118,
        ISSUE_METRIC_AVG_RUM_PERFORMANCE_PAGE_BUILD = 119,
        ISSUE_METRIC_AVG_RUM_PERFORMANCE_PAGE_LAYOUT = 120,
        ISSUE_METRIC_AVG_RUM_PERFORMANCE_FIRST_FRAME_ALL = 121,
        ISSUE_METRIC_QUANTILE_RUM_PERFORMANCE_FETCH_CONTEXT = 122,
        ISSUE_METRIC_QUANTILE_RUM_PERFORMANCE_PAGE_BUILD = 123,
        ISSUE_METRIC_QUANTILE_RUM_PERFORMANCE_PAGE_LAYOUT = 124,
        ISSUE_METRIC_QUANTILE_RUM_PERFORMANCE_FIRST_FRAME_ALL = 125,
        ISSUE_METRIC_RUM_PAGE_LOAD_SUCC_RATE = 126,
        ISSUE_METRIC_AVG_RUM_PERFORMANCE_APP_LAUNCH = 127,
        ISSUE_METRIC_AVG_RUM_PERFORMANCE_FIRST_SCREEN = 128,
        ISSUE_METRIC_AVG_RUM_PERFORMANCE_SCRIPT_EVALUATE = 129,
        ISSUE_METRIC_AVG_RUM_PERFORMANCE_PAGE_ROUTE = 130,
        ISSUE_METRIC_AVG_RUM_PERFORMANCE_FIRST_PAINT = 131,
        ISSUE_METRIC_AVG_RUM_PERFORMANCE_LCP = 132,
        ISSUE_METRIC_AVG_RUM_PERFORMANCE_TOTAL_RENDER = 133,
        ISSUE_METRIC_QUANTILE_RUM_PERFORMANCE_APP_LAUNCH = 134,
        ISSUE_METRIC_QUANTILE_RUM_PERFORMANCE_FIRST_SCREEN = 135,
        ISSUE_METRIC_QUANTILE_RUM_PERFORMANCE_SCRIPT_EVALUATE = 136,
        ISSUE_METRIC_QUANTILE_RUM_PERFORMANCE_PAGE_ROUTE = 137,
        ISSUE_METRIC_QUANTILE_RUM_PERFORMANCE_FIRST_PAINT = 138,
        ISSUE_METRIC_QUANTILE_RUM_PERFORMANCE_LCP = 139,
        ISSUE_METRIC_QUANTILE_RUM_PERFORMANCE_TOTAL_RENDER = 140,
        ISSUE_METRIC_QUANTILE_RUM_API_SLOW_RATE = 141,
        ISSUE_METRIC_QUANTILE_RUM_SETDATA_DURATION = 142,
        ISSUE_METRIC_AVG_RUM_SETDATA_DURATION = 143,
        ISSUE_METRIC_QUANTILE_RUM_SETDATA_SIZE = 144,
        ISSUE_METRIC_AVG_RUM_SETDATA_SIZE = 145,
        ISSUE_METRIC_QUANTILE_RUM_PERFORMANCE_LOAD_PACKAGE = 146,
        ISSUE_METRIC_AVG_RUM_PERFORMANCE_LOAD_PACKAGE = 147,
        ISSUE_METRIC_COUNT_RUM_PERFORMANCE_APP_LAUNCH = 148,
        ISSUE_METRIC_COUNT_RUM_PERFORMANCE_TOTAL_RENDER = 149,
        ISSUE_METRIC_RUM_API_SUCC_RATE = 150,
        ISSUE_METRIC_RUM_STATIC_FAIL_COUNT = 151,
        ISSUE_METRIC_RUM_PV_ERROR_RATE = 152,
        ISSUE_METRIC_RUM_PV_ERROR = 153,
        ISSUE_METRIC_LAG_REPORT_RATE = 160,
        ISSUE_METRIC_LAG_DEVICE_RATE = 161,
        ISSUE_METRIC_LAG_USER_RATE = 162,
        ISSUE_METRIC_COUNT_RUM_PERFORMANCE_LOAD_PACKAGE = 163,
        ISSUE_METRIC_COUNT_RUM_PERFORMANCE_SCRIPT_EVALUATE = 164,
        ISSUE_METRIC_COUNT_RUM_PERFORMANCE_FIRST_PAINT = 165,
        ISSUE_METRIC_COUNT_RUM_PERFORMANCE_FCP = 166,
        ISSUE_METRIC_COUNT_RUM_PERFORMANCE_LCP = 167,
        ISSUE_METRIC_COUNT_RUM_PERFORMANCE_PAGE_ROUTE = 168,
        ISSUE_METRIC_ELECTRON_PV_COUNT = 169,
        ISSUE_METRIC_ELECTRON_PV_UV_COUNT = 170,
        ISSUE_METRIC_ELECTRON_STATIC_SUCCESS_RATE = 171,
        ISSUE_METRIC_ELECTRON_STATIC_FAIL_RATE = 172,
        ISSUE_METRIC_ELECTRON_STATIC_STATUS_FAIL_COUNT = 173,
        ISSUE_METRIC_ELECTRON_STATIC_COUNT = 174,
        ISSUE_METRIC_ELECTRON_STATIC_DURATION_AVG = 175,
        ISSUE_METRIC_ELECTRON_STATIC_DURATION_QUANTILE = 176,
        ISSUE_METRIC_ELECTRON_STATIC_TRANSFER_SIZE_AVG = 177,
        ISSUE_METRIC_ELECTRON_STATIC_TRANSFER_SIZE_QUANTILE = 178,
        ISSUE_METRIC_ELECTRON_STATIC_DOMAIN_LOOK_UP_AVG = 179,
        ISSUE_METRIC_ELECTRON_STATIC_DOMAIN_LOOK_UP_QUANTILE = 180,
        ISSUE_METRIC_ELECTRON_STATIC_CONNECT_TIME_AVG = 181,
        ISSUE_METRIC_ELECTRON_STATIC_CONNECT_TIME_QUANTILE = 182,
        ISSUE_METRIC_ELECTRON_CUSTOM_COUNT = 183,
        ISSUE_METRIC_ELECTRON_CUSTOM_DURATION_AVG = 184,
        ISSUE_METRIC_ELECTRON_CUSTOM_DURATION_QUANTILE = 185,
        ISSUE_METRIC_ELECTRON_EVENT_PV_COUNT = 186,
        ISSUE_METRIC_ELECTRON_EVENT_UV_COUNT = 187,
        ISSUE_METRIC_ELECTRON_JS_ERROR_RATE = 188,
        ISSUE_METRIC_ELECTRON_ERROR_NATIVE_ERROR = 189,
        ISSUE_METRIC_ELECTRON_ERROR_CROSS_ERROR = 190,
        ISSUE_METRIC_ELECTRON_NATIVE_CROSS_ERROR = 191,
        ISSUE_METRIC_ELECTRON_BROWSER_ERROR_RATE = 192,
        ISSUE_METRIC_ELECTRON_RENDERER_ERROR_RATE = 193,
        ISSUE_METRIC_ELECTRON_JS_PROMISE_ERROR = 194,
        ISSUE_METRIC_ELECTRON_JS_AJAX_ERROR = 195,
        ISSUE_METRIC_ELECTRON_PV_ERROR_RATE = 196,
        ISSUE_METRIC_ELECTRON_WHITE_SCREEN = 197,
        ISSUE_METRIC_ELECTRON_WHITE_SCREEN_RATE = 198,
        ISSUE_METRIC_ELECTRON_SESSION = 199,
        ISSUE_METRIC_ELECTRON_SESSION_RATE = 200,
        ISSUE_METRIC_QUANTILE_ELECTRON_PERFORMANCE_FCP = 201,
        ISSUE_METRIC_QUANTILE_ELECTRON_PERFORMANCE_FIRST_SCREEN = 202,
        ISSUE_METRIC_COUNT_ELECTRON_PERFORMANCE_FIRST_SCREEN = 203,
        ISSUE_METRIC_ELECTRON_CRASH = 204,
        ISSUE_METRIC_ELECTRON_CRASH_COUNT = 205,
        ISSUE_METRIC_ELECTRON_CRASH_DEVICE_RATE = 206,
        ISSUE_METRIC_ELECTRON_CRASH_SESSION_RATE = 208,
        ISSUE_METRIC_JS_EXEC_ERROR = 209,
        ISSUE_METRIC_PROMISE_ERROR = 210,
        ISSUE_METRIC_AJAX_ERROR = 211,
        ISSUE_METRIC_RN_PV_ERROR_RATE = 212,
        ISSUE_METRIC_ELECTRON_JS_CUSTOM_ERROR = 213,
        ISSUE_METRIC_ELECTRON_JS_LOAD_ERROR = 214,
        ISSUE_METRIC_ELECTRON_CSS_LOAD_ERROR = 215,
        ISSUE_METRIC_ELECTRON_IMAGE_LOAD_ERROR = 216,
        ISSUE_METRIC_ELECTRON_MEDIA_LOAD_ERROR = 217,
        ISSUE_METRIC_ELECTRON_API_AJAX_ERROR = 218,
        ISSUE_METRIC_ELECTRON_API_RETCODE_ERROR = 219,
      }

      export enum TimeType {
        TIME_TYPE_UNKNOWN = 0,
        TIME_TYPE_DAY = 1,
        TIME_TYPE_HOUR = 2,
        TIME_TYPE_MINUTE = 3,
        TIME_TYPE_MINUTE5 = 4,
        TIME_TYPE_WEEK = 5,
        TIME_TYPE_MONTH = 6,
        TIME_TYPE_SECOND = 7,
        TIME_TYPE_ACCUMULATED = 8,
      }

      export enum AttachmentEncodeType {
        UNKNOWN = 0,
        NONE = 1,
        GZIP = 2,
        ZIP = 3,
        BASE64_GZIP = 4,
        ZIP_BASE64_GZIP = 5,
        GZIP_BASE64_GZIP = 6,
        GZIP_BASE64 = 7,
      }

      export enum FileType {
        Unknown = 0,
        System = 1,
        Other = 3,
        Times = 4,
      }

      export enum ClusterStackType {
        DEFAULT = 0,
        ANR_TRACE_MAIN_STACK = 1,
      }

    }

    export namespace common {
      export enum KeyDataType {
        NUMBER = 0,
        STRING = 1,
        ARRAY = 2,
        MAP = 3,
      }

    }

    export namespace manage_server {
      export enum ColumnType {
        UNKNOWN_COLUMN_TYPE = 0,
        NUMBER_COLUMN_TYPE = 1,
        STRING_COLUMN_TYPE = 2,
        DIMENSION_KEY_COLUMN_TYPE = 3,
        METRIC_COLUMN_TYPE = 4,
        PRESET_METRIC_COLUMN_TYPE = 5,
      }

      export enum DashboardType {
        UNKOWN_DASHBOARD_TYPE = 0,
        MY_DASHBOARD = 1,
        PUBLIC_DASHBOARD = 2,
        CUSTOM_DASHBOARD = 3,
      }

      export enum ChartType {
        UNKOWN_CHART_TYPE = 0,
        TREND = 1,
        BAR = 2,
        STACKED = 3,
        DISTRIBUTION = 4,
        PIE = 5,
        TABLE = 6,
        DataOverview = 7,
      }

      export enum ChartSize {
        UNKOWN_CHART_SIZE = 0,
        SMALL = 1,
        MEDIUM = 2,
        LARGE = 3,
      }

      export enum Operator {
        UNKOWN_OPERATOR = 0,
        SUM = 1,
        AVG = 2,
        DISTINCT = 3,
        MAX = 4,
        MIN = 5,
        P5 = 6,
        P10 = 7,
        P20 = 8,
        P25 = 9,
        P30 = 10,
        P40 = 11,
        P50 = 12,
        P60 = 13,
        P70 = 14,
        P75 = 15,
        P80 = 16,
        P90 = 17,
        P95 = 18,
        P99 = 19,
      }

    }

  }

}
